import React from 'react'
import $ from 'jquery';
import WithConsumer from "../context/WithConsumer";
import GridItem from "./GridItem";
import Post from "./Post";
import {ClipLoader} from "react-spinners";
import {createBrowserHistory} from "history";

const history = createBrowserHistory({
    forceRefresh: false
});

export const kGridNews = 'aktuality';
export const kGridProjects = 'projekty';

class Grid extends React.PureComponent {

    state = {
        openedPostId: 0
    };

    /**
     *
     */
    render = () => {

        const {context} = this.props;
        const posts = context.getPosts(this.props.filter);

        return (
            <div className='Grid'>
                <div className='Container Container--tall'>
                    {context.loading && (
                        <div className='Loader'>
                            <ClipLoader size={40}/>
                        </div>
                    )}
                    {!context.loading && posts.map((post, key) => (
                        <>
                            <GridItem
                                key={key}
                                post={post}
                                isOpened={this.state.openedPostId === post.id}
                                onOpen={() => this.openItem(post)}
                                onClose={this.closeItem}
                            />
                            {this.state.openedPostId === post.id && (
                                <>
                                    <div className='Grid__detail' key={-1}>
                                        <Post post={post} heading={false}/>
                                    </div>
                                    {(posts.length - 1) !== key && (
                                        <div
                                            className='Grid__placeholder'
                                            onClick={this.closeItem}
                                        />
                                    )}
                                </>
                            )}
                        </>
                    ))}
                </div>
            </div>
        );
    };

    /**
     *
     */
    openItem = (post) => {
        if (this.state.openedPostId === post.id) {
            return;
        }

        history.push(`/${this.props.filter}/${post.slug}`, {});
        this.setState({openedPostId: post.id}, () => {
            const element = $(`.Grid__item--opened`);
            $('html, body').animate({scrollTop: element.offset().top - 96}, {
                duration: 'medium'
            });
        });
    };

    /**
     *
     */
    closeItem = () => {
        history.push(`/${this.props.filter === kGridProjects ? kGridProjects : ''}`, {});
        this.setState({openedPostId: 0});
    }
}

export default WithConsumer(Grid);